// 渲染红包
import React, {memo} from 'react'
import styled from 'styled-components'
import RedPacket from "@/img/redpacket.png";

const TextMsgOrd = styled.div`
  width: 240px;
  height: 85px;
  margin-top: 8px;
  background: #FF9A14;
  border-radius: 4px;
  color: #fff;
  .redPacketHeader {
    height: 52px;
    display: flex;
    align-items: center;
    img {
      width: 36px;
      height: 36px;
      margin: 0 4px;
    }
    .redPacketWish {
      width: 180px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .packageLine {
    border-bottom: 1px solid #fff;
    opacity: 0.5;
  }
  .redPacketFooter {
    display: flex;
    align-items: center;
    padding: 0 8px;
    height: 32px;
    font-size: 12px;
  }
`

const TextCount = styled.div`
  color: #999999;
  font-size: 12px;
  margin-top: 4px;
`

const RenderRedPackageMsg = memo((props) => {
  const {value} = props
  let message = value.messageContent ? JSON.parse(value.messageContent) : {}
  const packetType = {1:'普通红包',2:'拼手气红包',3:'群激励红包'}
  return (
    <div>
      <TextMsgOrd>
        <div className="redPacketHeader">
          <div><img src={RedPacket} /></div>
          <div className="redPacketWish">{message.wish}</div>
        </div>
        <div className="packageLine"></div>
        <div className="redPacketFooter">{packetType[message.type]}</div>
      </TextMsgOrd>
      <TextCount>共{message.totalcnt}个红包，总金额{(message.totalamount/100).toFixed(2)}元</TextCount>
    </div>
  )
})

export default RenderRedPackageMsg